import { connect } from "react-redux";
import { RecapPayment } from "../screens/RecapPayment";
import { paymentRecapChangeField, paymentRecapResetError, paymentRecapValidateAndProceed, paymentRecapPlaceNameFilter } from "../reducers/paymentRecap";

function mapStateToProps(state) {
    const offer = state.offer;
    const form = state.paymentRecapReducer;
    return {
        offer, form
    }
}

function mapDispatchToProps(dispatch) {
    return {
        onChange: (name, value) => dispatch(paymentRecapChangeField(name, value)),
        resetError: name => dispatch(paymentRecapResetError(name)),
        validate: finished => dispatch(paymentRecapValidateAndProceed(finished)),
        addressPlaceNameFilter: value => dispatch(paymentRecapPlaceNameFilter(value)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RecapPayment);